import { Box, SxProps } from '@mui/material'

interface Props {
    sx?: SxProps
}

export const CustomDivider = ({ sx }: Props) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '1px',
                background: 'rgba(224, 224, 224, 1)',
                mt: '20px',
                ...sx,
            }}
        />
    )
}
